// ──────────────────────────────────────────────────────────────
//  Яамнуудын ID → Нэр (key = numeric id)
// ──────────────────────────────────────────────────────────────
export const yamList = {
  1: 'Хот байгуулалт, барилга, орон сууцжуулалтын яам',
  2: 'Байгаль орчин, уур амьсгалын өөрчлөлтийн яам',
  3: 'Гэр бүл, хөдөлмөр, нийгмийн хамгааллын яам',
  4: 'Цахим хөгжил, инновац, харилцаа холбооны яам',
  5: 'Боловсролын яам',
  6: 'Соёл, спорт, аялал жуулчлал, залуучуудын яам',
  7: 'Зам тээврийн яам',
  8: 'МУ-ын Шадар сайд',
  9: 'Онцгой байдлын газар',
  10: 'Эрүүл мэндийн яам',
};
